import { atom } from "recoil"

export const informationsRequestIdState = atom({
  key: "atoms/settings/informationsRequestIdState",
  default: 0,
})
